"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports.ThemeContext = void 0;
var _react = require("react");
var themes = exports.themes = Object.freeze({
  "default": 1,
  dark: 2,
  rewards: 3
});
var ThemeContext = exports.ThemeContext = /*#__PURE__*/(0, _react.createContext)(themes["default"]);